@app.filter "nbsp", ->
  (text) ->
    text.replace(/\s/g, '&nbsp;')